export const ForbiddenPage = () => {
  return (
    <div className="text-center forbidden">
      <h1>403</h1>
      <h4>Forbidden</h4>
      <p>Access to this resource on the server is denied</p>
    </div>
  ); 
};
